// extracted by mini-css-extract-plugin
export default {"host":"PageHeaderRow_host__ry5OZ"};